import React, { useState, Fragment, useCallback, useEffect } from 'react';
import { translate } from '../../Services/translation';
import { useDispatch, useSelector } from 'react-redux';
import {
    reloadPayment,
    //upgrade8.7  submitRequest,
    submitDone,
} from '../../Actions/Checkout.action';
import { update, loadError, reloadIngrid } from '../../Actions/Cart.action';
import { beginCheckoutEvent, removeFromCartEvent } from '../../Actions/Gtm.action';
import CoreComplimentaryProducts from '../ComplimentaryProducts';
//upgrade8.7 import * as debounce from 'lodash.debounce';
import { debounce } from 'lodash-es';
import { catchError } from '../../Actions/Error.action';

const mapCartToAbort = {};

const quantityDispatch = debounce((articleNumber, quantity, dispatch) => {
    mapCartToAbort[articleNumber] = new AbortController();
    dispatch(update(articleNumber, quantity, mapCartToAbort[articleNumber]))
        .then(() => {
            dispatch(reloadPayment());
            dispatch(reloadIngrid());
            beginCheckoutEvent();
        })
        .catch((ex) => dispatch(catchError(ex, (error) => loadError(error))));
}, 500);

const Cart = () => {
    const dispatch = useDispatch();
    const [removingRow, setRemovingRow] = useState({});
    const cart = useSelector((state) => state.cart);
    const [orderRows, setOrderRows] = useState(cart?.orderRows);
    const { discountRows } = cart;
    const { complimentaryProducts } = cart;
    useEffect(() => {
        setOrderRows(cart?.orderRows);
    }, [cart]);

    const removeOrderRow = useCallback(
        (articleNumber) =>
            dispatch(update(articleNumber, 0)).then(() => {
                dispatch(reloadPayment());
                dispatch(reloadIngrid());
                beginCheckoutEvent();
            }
            )[dispatch]
    );

    const errorQuantity = (articleNumber, errorName) => {
        document.getElementById(articleNumber).innerText = errorName;
        // //upgrade8.7  dispatch(submitRequest());
    };
    const handleQuantityInput = useCallback(
        (
            articleNumber,
            quantity,
            minimumQuantity,
            maximumQuantity,
            quantityStepping,
            rowSystemId,
            ensureCorrectness = true
        ) => {
            const re = /^[0-9\b]+$/;
            if (quantity === '' || re.test(quantity)) {
                // In case of onBlur event, we need ensureCorrectness as true in order to ensure if the value is a valid float number
                // In case of onChange event, we accept invalid float number, but we don't send any request to the server.
                //upgrade8.7 mapCartToAbort[articleNumber] && mapCartToAbort[articleNumber].abort();
                quantityDispatch && quantityDispatch.cancel();

                let floatQuantity = parseFloat(quantity);
                let validValue = !isNaN(floatQuantity) && floatQuantity > 0;
                if (ensureCorrectness) {
                    quantity = validValue ? floatQuantity : 1;
                    floatQuantity = quantity;
                    validValue = true;
                }
                document.getElementById(articleNumber).innerText = '';
                if (
                    parseInt(minimumQuantity) > 0 &&
                    parseInt(floatQuantity) < parseInt(minimumQuantity)
                ) {
                    errorQuantity(
                        articleNumber,
                        translate('product.minimumquantity') +
                        ' ' +
                        minimumQuantity
                    );
                } else if (
                    parseInt(maximumQuantity) > 0 &&
                    parseInt(floatQuantity) > parseInt(maximumQuantity)
                ) {
                    errorQuantity(
                        articleNumber,
                        translate('product.maximumquantity') +
                        ' ' +
                        maximumQuantity
                    );
                } else if (
                    parseInt(quantityStepping) > 0 &&
                    parseInt(floatQuantity) % parseInt(quantityStepping) !== 0
                ) {
                    var addQty =
                        parseInt(floatQuantity) % parseInt(quantityStepping);
                    errorQuantity(
                        articleNumber,
                        translate('product.multiplequantity') +
                        ' ' +
                        quantityStepping +
                        ' add ' +
                        addQty
                    );
                } else {
                    dispatch(submitDone());
                }
                const index = orderRows.findIndex(
                    (item) => item.rowSystemId === rowSystemId
                );
                const oldQuantity = parseFloat(orderRows[index].quantity);
                if (floatQuantity !== oldQuantity) {
                    mapCartToAbort[articleNumber] &&
                        mapCartToAbort[articleNumber].abort();
                    quantityDispatch && quantityDispatch.cancel();
                    validValue &&
                        quantityDispatch(articleNumber, quantity, dispatch);
                }
                const tempOrderRows = [...orderRows];
                tempOrderRows[index] = {
                    ...tempOrderRows[index],
                    quantity,
                };
                setOrderRows(tempOrderRows);
            }
        },
        [dispatch, orderRows]
    );

    const ProductImage = useCallback(({ order }) => {
        return (
            <img
                className="checkout-cart__image"
                src={order.image}
                // alt={order.name}
            />
        );
    }, []);

    const ProductName = useCallback(({ order }) => {
        return (
            <Fragment>
                <a href={order.url}>{order.name}</a>
                <span className="checkout-cart__art-nr">
                    {translate('order.articlenumber')} {order.articleNumber}
                </span>
                {order.bundleVariants && order.bundleVariants.map((value, key) => {
                    return (
                        <span className='product__article-no' key={key} >{value}</span>
                    );
                })}
                <span className="checkout-cart__brand-name">{order.brand}</span>
            </Fragment>
        );
    }, []);

    const Complimentary = useCallback(({ order }) => {
        const cartProductComplimentary = complimentaryProducts.filter((x) => {
            return x.complimentaryBaseArticleNumber == order.articleNumber;
        });
        return (
            <Fragment>
                <CoreComplimentaryProducts
                    complimentary={cartProductComplimentary}
                />
            </Fragment>
        );
    }, []);

    const ProductPrice = useCallback(({ order }) => {
        return (
            <Fragment>
                {order.campaignPrice ? (
                    <Fragment>
                        <div className="checkout-cart__campaign-price">
                            {order.campaignPrice}
                        </div>
                        <div className="checkout-cart__original-price">
                            {' '}
                            ({order.price})
                        </div>
                    </Fragment>
                ) : (
                    order.price
                )}
            </Fragment>
        );
    }, []);

    const ProductQuantity = useCallback(
        (order) => {
            return (
                <Fragment>
                    {order.isFreeGift ? (
                        <div>{order.quantity}</div>
                    ) : (
                        <div className="checkout-flex">
                            <input
                                className="checkout-cart__input"
                                type="number"
                                aria-label={translate("product.quantity")}
                                id={order.rowSystemId}
                                min={
                                    order.minimumQuantity > 0
                                        ? order.minimumQuantity
                                        : 1
                                }
                                maxLength={3}
                                max={
                                    order.maximumQuantity > 0
                                        ? order.maximumQuantity
                                        : 999
                                }
                                value={order.quantity.toString()}
                                step={
                                    order.quantityStepping > 0
                                        ? order.quantityStepping
                                        : 1
                                }
                                onChange={(event) =>
                                    handleQuantityInput(
                                        order.articleNumber,
                                        event.target.value,
                                        order.minimumQuantity,
                                        order.maximumquantity,
                                        order.quantitystepping,
                                        order.rowSystemId,
                                        false
                                    )
                                }
                                onBlur={(event) =>
                                    handleQuantityInput(
                                        order.articleNumber,
                                        event.target.value,
                                        order.minimumQuantity,
                                        order.maximumQuantity,
                                        order.quantityStepping,
                                        order.rowSystemId
                                    )
                                }
                            />
                            <span
                                id={order.articleNumber}
                                className="quantity-error"
                            ></span>
                        </div>
                    )}
                </Fragment>
            );
        },
        [handleQuantityInput]
    );

    const ProductTotalPrice = ({ order }) => {
        return (
            <Fragment>
                {order.totalCampaignPrice ? (
                    <Fragment>
                        <div className="checkout-cart__campaign-price">
                            {order.totalCampaignPrice}
                        </div>
                        <div className="checkout-cart__original-price">
                            {' '}
                            ({order.totalPrice})
                        </div>
                    </Fragment>
                ) : (
                    order.totalPrice
                )}
            </Fragment>
        );
    };

    const RemoveBtn = useCallback(
        ({ order }) => {
            return (
                <Fragment>
                    {!order.isFreeGift && !removingRow[order.rowSystemId] && (
                        <a
                            className="table__icon table__icon--delete"
                            onClick={() =>
                                setRemovingRow({
                                    ...removingRow,
                                    [order.rowSystemId]: true,
                                })
                            }
                            title={translate('general.remove')}
                        ></a>
                    )}
                    {!order.isFreeGift && removingRow[order.rowSystemId] && (
                        <Fragment>
                            <a
                                className="table__icon table__icon--accept"
                                onClick={async () => {
                                    await removeFromCartEvent(
                                        order.articleNumber
                                    );
                                    removeOrderRow(order.articleNumber);
                                }}
                                title={translate('general.ok')}
                            ></a>
                            <a
                                className="table__icon table__icon--cancel"
                                onClick={() =>
                                    setRemovingRow({
                                        ...removingRow,
                                        [order.rowSystemId]: false,
                                    })
                                }
                                title={translate('general.cancel')}
                            ></a>
                        </Fragment>
                    )}
                </Fragment>
            );
        },
        [removeOrderRow, removingRow]
    );

    const CartTotal = useCallback(({ cart }) => {
        return (
            <h3 className="text--right">
                {translate('checkout.cart.total')}: {cart.orderTotal}
            </h3>
        );
    }, []);

    return (
        <div className="row checkout__container">
            <div className="columns checkout-column small-12 checkout-cart__wrapper">
                <h3 className="checkout__section-title columns">
                    {translate('checkout.cart.title')}
                </h3>
                <div className="simple-table hide-for-small-only">
                    <div className="row small-unstack no-margin">
                        <div className="columns small-12 medium-4 large-5"></div>
                        <div className="columns small-3 medium-2 large-2">
                            {translate('checkout.cart.header.price')}
                        </div>
                        <div className="columns small-4 medium-2 large-2">
                            {translate('checkout.cart.header.quantity')}
                        </div>
                        <div className="columns small-5 medium-3 large-3">
                            {translate('checkout.cart.header.total')}
                        </div>
                    </div>
                    {orderRows.map((order, index) => (
                        <div
                            className="row small-unstack no-margin checkout-cart__row"
                            key={order.rowSystemId}
                        >
                            <div className="columns small-12 medium-4 large-5 checkout-cart__image-container">
                                <div className="checkout-cart__image-wrapper">
                                    <ProductImage key={'checkout-cart-row-image' + index} order={order} />
                                </div>
                                <div className="checkout-cart__image-info">
                                    <ProductName key={'checkout-cart-row-info' + index} order={order} />
                                </div>
                            </div>
                            <div className="columns small-3 medium-2 large-2 simple-table__cell--no-break-word">
                                <ProductPrice order={order} />
                            </div>
                            <div className="columns checkout-flex small-2 medium-2 large-2">
                                {ProductQuantity(order)}
                            </div>
                            <div className="checkout-cart__total-price columns small-2 medium-3 large-2 simple-table__cell--no-break-word">
                                <ProductTotalPrice order={order} />
                            </div>
                            <div className="columns small-3 medium-1 large-1">
                                <RemoveBtn order={order} />
                            </div>
                            {/* <div className='row'>
                                <Complimentary order={order} />
                            </div> */}
                        </div>
                    ))}
                    {/*{discountRows.map((order,index) => (*/}
                    {/*    <div*/}
                    {/*        className="row small-unstack no-margin checkout-cart__row"*/}
                    {/*        key={order.rowSystemId}*/}
                    {/*    >*/}
                    {/*        <div className="columns small-12 medium-4 large-5 checkout-cart__image-container">*/}
                    {/*            <div className="checkout-cart__image-info">*/}
                    {/*                <ProductName key={'checkout-cart-row-info-cnt'+index} order={order} />*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*        <div className="columns small-3 medium-2 large-2 simple-table__cell--no-break-word"></div>*/}
                    {/*        <div className="columns small-2 medium-2 large-2"></div>*/}
                    {/*        <div className="checkout-cart__total-price columns small-2 medium-3 large-2 simple-table__cell--no-break-word">*/}
                    {/*            <ProductTotalPrice order={order} />*/}
                    {/*        </div>*/}
                    {/*        <div className="columns small-3 medium-1 large-1"></div>*/}
                    {/*    </div>*/}
                    {/*))}*/}
                    <div className="row small-unstack no-margin checkout-cart__row">
                        <div className="columns">
                            <CartTotal cart={cart} />
                        </div>
                    </div>
                </div>
                <div className="small-12 simple-table checkout-mobile show-for-small-only">
                    {orderRows.map((order, index) => (
                        <div className="row no-margin" key={order.rowSystemId}>
                            <div className="columns small-3">
                                <ProductImage order={order} />
                            </div>
                            <div className="columns small-9">
                                <div className="row">
                                    <div className="small-8 columns">
                                        <div className="flex-container flex-dir-column align-center">
                                            <ProductName key={'checkout-cart-row-mobile' + index} order={order} />
                                        </div>
                                    </div>
                                    <div className="small-4 columns flex-container align-right">
                                        <RemoveBtn order={order} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="small-12 columns flex-container align-justify">
                                        <div>
                                            <ProductPrice order={order} />
                                        </div>
                                        <div>{ProductQuantity(order)}</div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="checkout-cart__total-price small-12 columns text--right">
                                        <ProductTotalPrice order={order} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                    {discountRows.map((order, index) => (
                        <div className="row no-margin" key={order.rowSystemId}>
                            <div className="columns">
                                <div>
                                    <ProductName key={'checkout-cart-norow' + index} order={order} />
                                </div>
                                <div className="checkout-cart__total-price text--right">
                                    <ProductTotalPrice order={order} />
                                </div>
                            </div>
                        </div>
                    ))}
                    <div className="row no-margin">
                        <div className="columns">
                            <CartTotal cart={cart} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Cart;
